/**
 * View-model partagé — détail d'une ligne commande produit.
 * Consommé par les modals Commerçant et Super Admin (même détail articles/options).
 * Ne recalcule pas les prix ; lit le snapshot.
 */

import {
  formatOrderOptionBusinessLines,
  normalizeOrderOptionGroups,
} from './orderOptionSnapshot.js';

export function getCommandeLigneDesignation(item) {
  return (
    item?.designationSnapshot ||
    item?.produit?.nom ||
    item?.nom ||
    'Article'
  );
}

/**
 * @param {object} item — ligne CommandeProduit (API)
 * @returns {{
 *   designation: string,
 *   quantite: number|null,
 *   commentaire: string|null,
 *   optionsRaw: unknown,
 *   optionGroups: Array,
 *   optionLines: string[],
 *   poidsSouhaite: number|string|null,
 *   typeDecoupe: string|null,
 *   poidsReel: number|string|null,
 *   prixUnitaire: number|null,
 *   prixTotal: number|null,
 * }}
 */
export function buildCommandeLigneDetailViewModel(item) {
  if (!item || typeof item !== 'object') {
    return {
      designation: 'Article',
      quantite: null,
      commentaire: null,
      optionsRaw: null,
      optionGroups: [],
      optionLines: [],
      poidsSouhaite: null,
      typeDecoupe: null,
      poidsReel: null,
      prixUnitaire: null,
      prixTotal: null,
    };
  }

  const optionsRaw = item.options ?? null;
  const optionGroups = normalizeOrderOptionGroups(optionsRaw);
  const optionLines = formatOrderOptionBusinessLines(optionsRaw);

  return {
    designation: getCommandeLigneDesignation(item),
    quantite: item.quantite != null ? Number(item.quantite) : null,
    commentaire:
      item.commentaire != null && String(item.commentaire).trim()
        ? String(item.commentaire)
        : null,
    optionsRaw,
    optionGroups,
    optionLines,
    poidsSouhaite: item.poidsSouhaite ?? null,
    typeDecoupe: item.typeDecoupe ?? null,
    poidsReel: item.poidsReel ?? null,
    prixUnitaire: item.prixUnitaire != null ? Number(item.prixUnitaire) : null,
    prixTotal: item.prixTotal != null ? Number(item.prixTotal) : null,
  };
}
